import { Controller, FieldValues, FieldPath, Control } from "react-hook-form";
import { Password } from "../common/Password";

interface ControlledPasswordProps<T extends FieldValues> {
    name: FieldPath<T>;
    control: Control<T>;
    label?: string;
    error?: string;
    placeholder?: string;
}

const ControlledPassword = <T extends FieldValues>(props: ControlledPasswordProps<T>) => {
    const { control, name, label, error, placeholder } = props;
    
    return (
        <div className="flex flex-col items-start gap-1 w-full">
            {label && <div>{label}</div>}
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <Password
                        value={field.value || ""}
                        onChange={field.onChange}
                        error={error}
                        placeholder={placeholder}
                    />
                )}
            />
        </div>
    );
};

export { ControlledPassword };
